<script lang="ts">
    import { getDashboardCtx } from "../../state/dashboard.svelte";
    import { translate } from "@/utils/format";
    import { qrSvg } from "../../lib/qr";

    const store = getDashboardCtx();
    let qrEl = $state<HTMLElement | null>(null);

    // Keep QR preview up to date (skip while the code is being edited).
    $effect(() => {
        if (!qrEl || store.editingCode || !store.referralLink) return;
        try {
            qrEl.innerHTML = qrSvg(store.referralLink);
        } catch {
            // ignore
        }
    });
</script>

<div class="referrals__qrLink {store.editingCode ? 'editing' : ''}">
    <div class="referralField">
        <label for="referralCodeInput"
            >{translate(
                "PARTNER_REFERRAL_CODE",
                "Tu código de referido",
            )}</label
        >
        <div class="referralField__row">
            <input
                id="referralCodeInput"
                type="text"
                value={store.referralCode}
                disabled={!!store.stripeAccountId && !store.editingCode}
                oninput={(e: any) =>
                    store.setReferralCode(e.target.value)}
                onfocus={(e: any) => e?.currentTarget?.select?.()}
            />
            {#if !store.editingCode && store.stripeAccountId}
                <button
                    type="button"
                    class="iconAction iconAction--mini"
                    onclick={store.enableEditCode}
                    title={translate("PARTNER_EDIT", "Editar")}
                    aria-label={translate("PARTNER_EDIT", "Editar")}
                >
                    <p>{translate("PARTNER_EDIT", "Editar")}</p>
                    <i class="fal fa-pen"></i>
                </button>
            {/if}
        </div>
    </div>

    <div class="referralField">
        <label for="referralLinkInput"
            >{translate(
                "PARTNER_REFERRAL_LINK",
                "Tu enlace de referido",
            )}</label
        >
        <p class="referralField__hint">
            {translate(
                "PARTNER_REFERRAL_LINK_HINT",
                "Tu link ya incluye tu código. Compártelo.",
            )}
        </p>
        <div class="referralField__row">
            <input
                id="referralLinkInput"
                type="text"
                readonly
                value={store.referralLink}
                onclick={(e: any) => e?.currentTarget?.select?.()}
                onfocus={(e: any) => e?.currentTarget?.select?.()}
            />
            {#if !store.editingCode}
                <button
                    type="button"
                    class="iconAction iconAction--mini"
                    onclick={store.copyLink}
                    title={translate(
                        "PARTNER_COPY_LINK",
                        "Copiar enlace",
                    )}
                    aria-label={translate(
                        "PARTNER_COPY_LINK",
                        "Copiar enlace",
                    )}
                >
                    <p>
                        {translate(
                            "PARTNER_COPY_LINK",
                            "Copiar enlace",
                        )}
                    </p>
                    <i class="fal fa-copy"></i>
                </button>
            {/if}
        </div>
    </div>

    {#if store.editingCode}
        <div class="referrals__buttons">
            <button
                class="button --success"
                onclick={store.updateReferralCode}
            >
                {translate("PARTNER_SAVE", "Guardar")}
            </button>
            <button
                class="button --delete"
                onclick={store.cancelEditCode}
            >
                {translate("PARTNER_CANCEL", "Cancelar")}
            </button>
        </div>
    {/if}

    <div class="referralQr">
        <div class="referralQr__head">
            <span>
                {translate("PARTNER_QR_TITLE", "QR")}
            </span>
            {#if !store.editingCode}
                <button
                    type="button"
                    class="iconAction iconAction--mini"
                    onclick={store.downloadQR}
                    title={translate(
                        "PARTNER_DOWNLOAD_QR_HINT",
                        "PNG listo para compartir",
                    )}
                    aria-label={translate(
                        "PARTNER_DOWNLOAD_QR",
                        "Descargar QR",
                    )}
                >
                    <p>
                        {translate(
                            "PARTNER_DOWNLOAD_QR",
                            "Descargar QR",
                        )}
                    </p>
                    <i class="fal fa-arrow-to-bottom"></i>
                </button>
            {/if}
        </div>
        <p class="referralQr__hint">
            {translate(
                "PARTNER_QR_HINT",
                "Escanéalo para instalar Caloo con tu enlace.",
            )}
        </p>
        <div
            bind:this={qrEl}
            class="referrals__QRGenertor"
        ></div>
    </div>
</div>
